import { LoyaltyOfferType } from "../../../utils/loyaltyTypes";
import type { AddonGroupType } from "../../../utils/types";
import type {
  OrderCartV2Line,
  OrderCartV2OfferSelection,
  OrderCartV2Output,
} from "./OrderCartV2Types";

type LoyaltyApplyRedirect = {
  itemId?: number;
  subItemId?: number;
  loyaltyItemFromListOffer?: LoyaltyOfferType;
};

type LoyaltyRedemptionSession = {
  offer: LoyaltyOfferType;
  offerApplicationId: string;
  /** Lines + quantities sent as EXPLICIT selections on next calculate */
  pendingSelections?: OrderCartV2OfferSelection[];
  /** Buy-side lines sent as EXPLICIT `triggers`. Absent for bundles. */
  pendingTriggers?: OrderCartV2OfferSelection[];
  /** lineIds pushed during this redemption (removed on removeLoyaltyOffer / INVALID) */
  addedLineIds?: string[];
};

type LoyaltyPayWithPointsSession = {
  requestedPoints: number;
  useMaxPoints?: boolean;
};

/** Which of the offer page's two steps is showing; carried in the URL. */
export type LoyaltyOfferBuilderStep = "select" | "customise";

type LoyaltyOfferBuilderState = {
  offerId: string;
  buySelections: Record<string, number>;
  rewardSelections: Record<string, number>;
  /** Keyed `${group}:${entityId}:${n}` so repeats customise independently. */
  customisations: Record<string, LoyaltyOfferBuilderCustomisation>;
  note: string;
};

export type LoyaltyOfferBuilderCustomisation = {
  /** Chosen addons, in the `allAddonGroups` shape the line builder expects. */
  addonGroups: AddonGroupType[];
  isComplete: boolean;
};

export type LoyaltyCartState = {
  /** Request/response cart lines — V2 path only */
  lines: OrderCartV2Line[];
  /** Last successful calculateOrderCartV2 response */
  result?: OrderCartV2Output;
  payWithPoints?: LoyaltyPayWithPointsSession;
  /** From getCustomerLoyaltyOffers */
  customerOffers?: LoyaltyOfferType[];
  /** Active redeem session; undefined when no offer selected */
  redemption?: LoyaltyRedemptionSession;
  /** In-flight UI: item-from-list popup, item-page addon redirect */
  applyFlow?: {
    selectedOfferId?: string;
    redirect?: LoyaltyApplyRedirect;
  };
  /**
   * Offer failure surfaced by the create-receipt response (V2 flow). Drives the
   * OfferError popup using the new loyaltyV2 offer format instead of the legacy
   * `cartAndLoyaltyReducer.offerErrorReason`.
   */
  offerError?: {
    code?: string;
    message?: string;
  };
  /** In-progress guest-built offer; cleared on commit or abandon. */
  offerBuilder?: LoyaltyOfferBuilderState;
};

export const initialLoyaltyCartState: LoyaltyCartState = {
  lines: [],
};
